export const theme = {
  colors: {
    primary: '#fff',
    secondary: '#fbbd61',
    accent: '#60a5fa',
    background: '#0f172a',
  },
};
